import { useState } from "react";

export const useEditMode = () => {
    const [isEditMode, setIsEditMode] = useState(false);

    const enableEdit = () => setIsEditMode(true);
    const disableEdit = () => setIsEditMode(false);

    return {
        isEditMode,
        enableEdit,
        disableEdit
    };
};
